module.exports = __webpack_public_path__ + "statics/img/image3.9924ef0a.png";